import type { ReactNode } from 'react';

interface SectionHeaderProps {
  eyebrow: string;
  title: string;
  description?: string;
  action?: ReactNode;
  align?: 'left' | 'center';
}

export default function SectionHeader({
  eyebrow,
  title,
  description,
  action,
  align = 'left',
}: SectionHeaderProps) {
  return (
    <div
      className={`flex flex-col gap-4 md:flex-row md:items-end ${
        align === 'center' ? 'md:flex-col md:items-center md:text-center' : 'md:justify-between'
      }`}
    >
      <div className={align === 'center' ? 'max-w-2xl' : 'max-w-2xl'}>
        <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.18em] text-primary-600">
          <span className="h-px w-6 bg-primary-400"></span>
          {eyebrow}
        </span>
        <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {description && (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">{description}</p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}